import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  getByTask(id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}schedule/task/${id}`, AUTH_HEADERS())
  },
  create(schedule) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}schedule`, schedule, AUTH_HEADERS())
  },
  update(schedule) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}schedule/update`, schedule, AUTH_HEADERS())
  },
  delete(id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}schedule/delete/${id}`, AUTH_HEADERS())
  }
}
